// src/utils/cornerstoneInit.js
import { cache, init as coreInit } from "@cornerstonejs/core";
import { init as dicomLoaderInit } from "@cornerstonejs/dicom-image-loader";

let initializationPromise = null;

// 512MB cache size - keeps LRU eviction active during multi-series sessions
const MAX_CACHE_SIZE_BYTES = 512 * 1024 * 1024;

export async function initializeCornerstoneOnce() {
  if (initializationPromise) return initializationPromise;

  initializationPromise = (async () => {
    await coreInit();
    await dicomLoaderInit();

    // Configure cache size to handle larger datasets
    // Cornerstone uses LRU eviction when cache is full
    cache.setMaxCacheSize(MAX_CACHE_SIZE_BYTES);
  })();

  return initializationPromise;
}
